import { Component, Input, OnInit } from '@angular/core';
import { Organization } from "../../../../model/organization";
import {ApiKeysService} from "../../../../services/apikeys.service";
import {CommonMessagesService} from "../../../../services/common-messages.service";

@Component({
  selector: 'app-organization-api',
  templateUrl: './organization-api.component.html',
  styleUrls: ['./organization-api.component.scss']
})
export class OrganizationApiComponent implements OnInit {

  @Input()
  public organization: Organization;

  public apiKey: string;
  public loadingApiKey: boolean;

  constructor(private apiKeysService: ApiKeysService,
              private commonMessagesService: CommonMessagesService) { }

  ngOnInit(): void {
    this.loadingApiKey = true;
    this.apiKeysService.getOrganizationApiKey(this.organization.tenant.uuid, this.organization.uuid)
      .toPromise().then( response => this.apiKey = response.apiKey)
      .finally(() => this.loadingApiKey = false);
  }

  confirmAndNewApiKey(): void {
    this.commonMessagesService.showGenerateNewApiKeyConfirmation(() => {
      this.loadingApiKey = true;
      this.apiKeysService.getNewOrganizationApiKey(this.organization.tenant.uuid, this.organization.uuid)
        .toPromise().then( response => this.apiKey = response.apiKey)
        .finally(() => this.loadingApiKey = false);
    });
  }

  newApiKey(): void {
    this.loadingApiKey = true;
    this.apiKeysService.getNewOrganizationApiKey(this.organization.tenant.uuid, this.organization.uuid)
      .toPromise().then( response => this.apiKey = response.apiKey)
      .finally(() => this.loadingApiKey = false);
  }

}
